interface WaiverMatchCriterion {
  type: string;
  name: string;
  match: string;
  sprite: string;
  title: string;
  description: string;
}

export const WAIVER_MATCH_CRITERIA: WaiverMatchCriterion[] = [
  {
    type: 'travelDates',
    name: 'TRAVEL_DATES',
    match: 'MATCH',
    sprite: 'sprite-calendar-24',
    title: 'Travel Dates',
    description:
      'This flight departs or arrives on a date within the applicable date range of the waiver.',
  },
  {
    type: 'flight',
    name: 'SPECIFIC_FLIGHT',
    match: 'MATCH',
    sprite: 'sprite-airplane-24',
    title: 'Flight',
    description:
      'This specific flight was called out in the waiver as being eligible.',
  },
  {
    type: 'airline',
    name: 'AIRLINE_RELATIONSHIP',
    match: 'MATCH',
    sprite: 'sprite-airplane-24',
    title: 'Airlines',
    description:
      'The operating and marketing airlines for this flight match one of the airline relationships specified in the waiver.',
  },
  {
    type: 'airline',
    name: 'PRIMARY_MARKETING_AIRLINE',
    match: 'MATCH',
    sprite: 'sprite-airplane-24',
    title: 'Primary Marketing Airline',
    description:
      'The primary marketing airline for this flight is the airline that issued the waiver.',
  },
  {
    type: 'airline',
    name: 'OPERATING_AIRLINE',
    match: 'MATCH',
    sprite: 'sprite-airplane-24',
    title: 'Operating Airline',
    description:
      'The marketing airline (which may, or may not be the operating airline) for this flight matches the criteria specified in the waiver.',
  },
  {
    type: 'airline',
    name: 'JOINT_VENTURE_AIRLINE',
    match: 'MATCH',
    sprite: 'sprite-airplane-24',
    title: 'Joint Business Partner Airline',
    description:
      'The airline marketing or operating this flight is a joint business partner for the airline that issued the waiver.',
  },
  {
    type: 'airport',
    name: 'AIRPORTS',
    match: 'MATCH',
    sprite: 'sprite-airport-tower-24',
    title: 'Airports',
    description:
      'This flight departs from or arrives into an airport that was explicitly included in the waiver or is in the region specified by the waiver.',
  },
  {
    type: 'ticket',
    name: 'TICKET_STOCK',
    match: 'MATCH',
    sprite: 'sprite-ticket-24',
    title: 'Ticket Stock Matched',
    description:
      'At least one ticket in the PNR was ticketed on the stock of the issuing carrier. When multiple tickets are issued for a PNR, the matching ticket may, or may not, be for the flight that matched the waiver. The ticket was issued on or before the “ticket by” date specified in the waiver.',
  },
  {
    type: 'ticket',
    name: 'TICKET_STOCK',
    match: 'NON_MATCH',
    sprite: 'sprite-ticket-24',
    title: 'Ticket Stock Did Not Match',
    description:
      'None of the ticket(s) in the PNR was ticketed on the stock of the issuing carrier. However, the tickets were issued on or before the “ticket by” date in the waiver. We recommend that you check the ticket requirements in the waiver and the tickets in the PNR to verify eligibility.',
  },
  {
    type: 'ticket',
    name: 'TICKET_STOCK',
    match: 'TRIP_MISSING_DATA',
    sprite: 'sprite-ticket-24',
    title: 'No Ticketing Data Found in the PNR',
    description:
      'We did not receive any ticketing information for this PNR, so we were unable to verify that the ticket(s) were issued on the stock of the carrier that issued the waiver or that the ticket was issued on or before the “Ticket by” date. Please review the ticketing requirements to verify eligibility.',
  },
  {
    type: 'ticket',
    name: 'TICKET_STOCK',
    match: 'WAIVER_MISSING_DATA',
    sprite: 'sprite-ticket-24',
    title: 'No Ticketing Data Specified in the Waiver',
    description:
      'The waiver data received did not specify ticket stocks required for eligibility for the waiver. Please review the ticketing requirements in the waiver or contact the airline to verify eligibility.',
  },
];